import React from 'react'
import '../Styles/FamilyCampPage1.scss';

function FamilyCampPage1() {
   return (
      <div className="familyCampPage1Content">
         <div className="familyCampPage1Container">
            <div className="familyCampPage1Title">
               Family Camp
            </div>
            <div div className="familyCampPage1Description">
               Families are greatly helped through Bible-based preaching <br></br>
               on marriage, the home, obeying parents, and raising kids.<br></br>
               Bring the whole famiy to experience a helpful week of fun!
            </div>
            <div className="familyCampPage1WeeksContainer">
               <div className="familyCampPage1Weeks">
                  <div className="familyCampWeek1">
                     <div className="familyWeek1Title">
                        Week One
                     </div>
                     <div className="familyWeek1Content">
                        June 12 - June 16, 2023
                     </div>
                  </div>

                  <div className="vl"></div>

                  <div className="familyCampWeek2">
                     <div className="familyWeek2Title">
                        Week Two
                     </div>
                     <div className="familyWeek2Content">
                        June 26 - June 30, 2023
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}
export default FamilyCampPage1;